module.exports = __webpack_public_path__ + "assets/img/email-90d39591.png";